import { render, staticRenderFns } from "./AdminNewsAddNew.vue?vue&type=template&id=38776666&scoped=true"
import script from "./AdminNewsAddNew.vue?vue&type=script&lang=js"
export * from "./AdminNewsAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38776666",
  null
  
)

export default component.exports